// @ts-check
import React, { Component } from 'react';
import { reduxForm, reset } from 'utils/reduxFormWrapper';
import api from 'utils/api';
import { flashSuccess } from 'shared/actions/UnboundFlashMessageActions';
import HForm, { SelectField } from 'shared/containers/portal_layout/HForm';
import { required } from 'utils/validation';
import SpinnerButton from 'shared/components/SpinnerButton';

class _UpdateSpecialtyForm extends Component {
  constructor(props) {
    super(props);
    this.state = { specialties: null };
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    api.get('/shared/api/specialties.json').then(response => {
      this.setState({ specialties: response.data.specialties });
    });
  }

  submit(formValues) {
    const { apiEndpoint, referralId } = this.props;
    return api
      .put(`${apiEndpoint}/referrals/${referralId}/specialty`, {
        specialty_id: formValues.specialtyId,
      })
      .then(response => {
        this.props.dispatch(flashSuccess({ message: 'Referral specialty updated.' }));
        this.props.handleSuccess();
        this.props.dispatch(reset('updateSpecialty'));
        return null;
      });
  }

  render() {
    const { handleSubmit, submitting } = this.props;
    const { specialties } = this.state;

    return (
      <HForm onSubmit={handleSubmit(this.submit)}>
        <div className="modal-header">
          <h3>Referral Specialty</h3>
        </div>
        <div className="modal-body" style={{ width: 600 }}>
          <SelectField
            name="specialtyId"
            label="Select Specialty"
            options={specialties}
            className="input-xlarge specialty-select"
            valueKey="id"
            labelKey="name"
            validate={required}
            autoSelect={specialties && specialties.length === 1}
          />
        </div>
        <div className="modal-footer">
          <SpinnerButton className="btn btn-primary" type="submit" loading={submitting}>
            Update
          </SpinnerButton>
        </div>
      </HForm>
    );
  }
}

const UpdateSpecialtyForm = reduxForm({ form: 'updateSpecialty' })(_UpdateSpecialtyForm);

export { UpdateSpecialtyForm };
